import Dispatch from "./client";

const urls = {
  register: {
    url: "/register",
    method: "post",
  },
  login: {
    url: "/username-login",
    method: "post",
  },
  signin: {
    url: "/signin",
    method: "post",
  },
  logout: {
    url: "/logout",
    method: "get",
  },
  checkUser: {
    url: '/check-user',
    method: 'get'
  },
  sendOTP: {
    url: '/send-otp',
    method: 'post'
  }
};

function api () {
  return {
    register: (data) => Dispatch(urls.register, data.params, data.payload, data.options),
    login: (data) => Dispatch(urls.login, data.params, data.payload, data.options),
    logout: (data) => Dispatch(urls.logout, data.params, data.payload, data.options),
    signin: (data) => Dispatch(urls.signin, data.params, data.payload, data.options),
		checkUser: (data) => Dispatch(urls.checkUser, data.params, data.payload, data.options),
		sendOTP: (data) => Dispatch(urls.sendOTP, data.params, data.payload, data.options)
  };
}

export default api();
